var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Hide",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 8.438,
    viewBox: "0 0 18 8.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Hide-2",
    "data-name": "Hide",
    d: "M2.329,6.375a.844.844,0,0,1,1.181.152l0,0,.022.027c.022.026.058.069.109.124a6.57,6.57,0,0,0,.478.468A9.118,9.118,0,0,0,6.131,8.489,10.854,10.854,0,0,0,11,9.575a10.854,10.854,0,0,0,4.869-1.086,9.117,9.117,0,0,0,2.009-1.341,6.59,6.59,0,0,0,.478-.468c.051-.055.087-.1.109-.124l.022-.027,0,0a.844.844,0,0,1,1.336,1.031v0l0,0,0,.006-.014.017-.045.054c-.037.045-.09.106-.159.181a8.232,8.232,0,0,1-.6.589,10.565,10.565,0,0,1-1.63,1.184l1.374,2.691a.844.844,0,1,1-1.5.767l-1.383-2.708a12.534,12.534,0,0,1-4.013.893v2.556a.844.844,0,0,1-1.688,0V11.238a12.535,12.535,0,0,1-4.013-.893L4.76,13.053a.844.844,0,0,1-1.5-.767L4.631,9.594A10.562,10.562,0,0,1,3,8.41a8.247,8.247,0,0,1-.6-.589c-.069-.075-.121-.136-.159-.181L2.2,7.585l-.014-.017,0-.006,0,0h0A.845.845,0,0,1,2.329,6.375Z",
    transform: "translate(-2 -6.2)",
    fill: "#373737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.606436a05f35b9c267bdf443f1cacbbf.svg";
export { ForwardRef as ReactComponent };